import { useCallback } from 'react';
import { Box, Text } from '@frameio/vapor';
import { useTrackRecentSearchSelected } from '../../../../../shared/contexts/SearchAnalyticsContext';
import { SearchCell } from '../shared';
import TEXT from './generated/TEXT/RecentSearches';

TEXT.DEFINE({
  /** Section title for recent search history */
  title: 'History',
});

type RecentSearchesProps = {
  recentSearches: string[];
  onClickRecentSearch: (query: string) => void;
  onRemoveRecentSearch: (query: string) => void;
};

export const RecentSearches = ({
  recentSearches,
  onClickRecentSearch,
  onRemoveRecentSearch,
}: RecentSearchesProps) => {
  const hasRecentSearches = recentSearches.length > 0;
  const trackRecentSearchSelected = useTrackRecentSearchSelected();

  const handleOnClickRecentSearch = useCallback(
    (query: string) => {
      trackRecentSearchSelected(query);
      onClickRecentSearch(query);
    },
    [onClickRecentSearch, trackRecentSearchSelected]
  );

  if (!hasRecentSearches) return null;

  return (
    <div>
      <Box alignItems="center" height={32} padding={8}>
        <Text color="tertiary" fontWeight="medium" variant="secondary">
          {TEXT.title}
        </Text>
      </Box>
      <Box
        alignItems="flex-start"
        display="flex"
        flexDirection="column"
        width="100%"
      >
        {recentSearches.map((query) => (
          <SearchCell
            key={query}
            onClick={handleOnClickRecentSearch}
            onRemove={onRemoveRecentSearch}
            searchQuery={query}
          />
        ))}
      </Box>
    </div>
  );
};
